"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var CheckboxInputOption = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("label", { className: "estimateForm-CheckboxInputOption" },
        react_1.default.createElement("input", { type: "checkbox", onChange: store.handleChange, onBlur: store.handleBlur, name: store.name, value: store.value, checked: store.isChecked, className: "estimateForm-CheckboxInputOption_Input" }),
        react_1.default.createElement("span", { className: "estimateForm-CheckboxInputOption_Label" },
            store.label,
            store.description &&
                react_1.default.createElement("span", { className: "estimateForm-CheckboxInputOption_Description" },
                    ": ",
                    store.description))));
});
exports.default = CheckboxInputOption;
